import { Box, Center, Image, VStack } from "native-base";
import React from "react";
import LoginPageCard from "../../../containers/loginPageCards";
import Logo from "../../../utils/logo";

const LoginPageMobileResponsive = () => {
  return (
    <VStack w="100%" h={"100%"}>
      <Center mt={10} mb={6}>
        <Logo w="275px" h="80px" />
      </Center>
      <Image
        source={{
          uri: require("../../../utils/quickLinkImages/Travel insurance-pana 1.png"),
        }}
        alt="image"
        width={"250"}
        height={"250"}
        alignSelf={"flex-end"}
      />
      <Box alignItems={"center"} justifyContent={"center"}>
        <LoginPageCard pl="25px" pr="25px" py="0" />
      </Box>
    </VStack>
  );
};

export default LoginPageMobileResponsive;
